import * as _ from 'lodash-es';
import React from 'react';
import type {
  BreadcrumbItem,
  BreadcrumbsProps,
} from '../components/Breadcrumbs';
import Breadcrumbs from '../components/Breadcrumbs';
import type { DocumentType } from '../graphql/generated/gql';
import { gql } from '../graphql/generated/gql';
import topicPath from '../utils/url/topicPath';
import * as styles from './PostBreadcrumbs.module.scss';

const POST_BREADCRUMBS_TOPIC_FRAGMENT = gql(`
  fragment PostBreadcrumbs_topic on Topic {
    id
    name
    ancestors {
      id
      name
    }
    ...topicPath_topic
  }
`);

interface PostBreadcrumbsProps extends Partial<BreadcrumbsProps> {
  link?: boolean;
  showRoot?: boolean;
  topic: DocumentType<typeof POST_BREADCRUMBS_TOPIC_FRAGMENT>;
  names?: React.ReactNode[];
}

const PostBreadcrumbs = ({
  link = false,
  showRoot = false,
  topic,
  names = [],
  ...breadcrumbsProps
}: PostBreadcrumbsProps) => {
  const ancestors = topic.ancestors ?? [];

  const items: BreadcrumbItem[] = _.zip([topic, ...ancestors] as const, names)
    .toReversed()
    .map(([t, name]) => {
      const item: BreadcrumbItem = {
        name: name || t?.name,
      };
      if (link) {
        item.to = topicPath(topic);
      }

      return item;
    });

  if (showRoot) {
    items.unshift({ name: 'Topics', to: link ? '/topics' : undefined });
  }

  return (
    <div className={styles.container}>
      <Breadcrumbs items={items} {...breadcrumbsProps} />
    </div>
  );
};

export default PostBreadcrumbs;
